<template>
	<div class="common-space-from-logo">
		<div class="">
			<h1 class="mb-13 template-title">Ready to send? Make sure this is right:</h1>
			<p class="custom-content chatbot-custom-content" v-if="community.content && community.content.formConfirmation" v-html="community.content.formConfirmation"></p>
		</div>
		<hr class="chatbot-request-review-hr" />
		<div class="email-request-review">
			<div class="template-request-review">
				<h2 v-if="ask.first && ask.last">{{ ask.first + ' ' +  ask.last }}</h2>
				<h5 v-if="ask.email">{{ ask.email.toString() }}</h5>
				<h6>{{ask.subject}}</h6>
				<p class="font-color">{{ask.text}}</p>
			</div>
		</div>
		<div class="btn-block">
			<div class="row">
				<div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
					<button :style="styleSubmitBtn" @click="sendCreate()" class="btn btn_info btn-feedbackupdatenew active template-button">Submit</button>
				</div>
				<div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 text-right">
					<button :style="styleEditBtn"  @click="editCreate()" class="btn editBtn btn-feedbackupdatenew btn_info template-button">Edit</button>
				</div>
			</div>
		</div>
	</div>
</template>

<!-- Script-->
<script>
import Button from './Button.vue';
export default {
  components: { Button },
  	props: {
		community: {
			required: true
		},
		ask: {
			required: true
		}
	},
	data() {
		return {
			submitBtn: {
				colorBackd: '#9178A0',
				color: '#ffffff'
			},
			editBtn: {
				colorBackd: '#CBA8E0',
				color: '#ffffff'
			}
		};
	},
  	computed: {
		styleSubmitBtn() {
			return {
				'color': this.submitBtn.color,
				'background-color': this.submitBtn.colorBackd
			};
		},
		styleEditBtn() {
			return {
				'color': this.editBtn.color,
				'background-color': this.editBtn.colorBackd
			};
		}
	},
	methods: {
		sendCreate() {
			this.$emit('submitAsk', true)
		},
		editCreate() {
			this.$emit('editAsk', true)
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/CommunityRequestReviewPage.vue